import moment from "moment";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { API_GET } from "../../helpers/api";
import * as actions from "../actions/bilateralAgreements";
import {
  GET_BILATERAL_AGREEMENTS_HISTORY_REQUEST,
  GET_BILATERAL_AGREEMENTS_REQUEST,
  GET_CERTIFICATES_REQUEST,
} from "../types";

function* watchGetCertificates() {
  yield takeEvery(GET_CERTIFICATES_REQUEST, getCertificates);
}

function* getCertificates(action) {
  try {
    const res = yield call(apiGetCertificates, action.payload);
    const documentCount = res.data.documentCount;
    const blockedDocumentCount = res.data.blockedDocumentCount;

    const items = res.data.items.reduce((acc, value) => {
      let now = new Date();
      let expireDate = moment(value.productionData.expireDate);
      let durationOfUse = moment(now).diff(expireDate, "months");
      if (durationOfUse < 0) {
        durationOfUse = 0;
      }
      acc.push({
        ...value,
        stationId: value.productionData.station.stationId,
        stationName: value.productionData.station.stationName,
        productionMonth: moment(value.productionData.term).format("M"),
        productionYear: moment(value.productionData.term).format("YYYY"),
        productionPeriod: value.productionData.term,
        durationOfUse: durationOfUse,
        localTerm: moment(value.productionData.exportedAt).format(
          "DD.MM.YYYY HH:mm"
        ),
      });
      return acc;
    }, []);
    const payload = {
      items: items,
      total: {
        totalItemCount: res.data.totalItemCount,
        totalPageCount: res.data.totalPageCount,
      },
      documentCount: documentCount,
      blockedDocumentCount: blockedDocumentCount,
    };

    yield put(actions.getCertificatesSucceeded(payload));
  } catch (err) {
    yield put(actions.getCertificatesFailed());
  }
}

function* watchGetBilateralAgreements() {
  yield takeEvery(GET_BILATERAL_AGREEMENTS_REQUEST, getBilateralAgreements);
}

function* getBilateralAgreements(action) {
  try {
    if (action.payload) {
      const [sellerInfoRes, buyerInfoRes] = yield all([
        call(apiGetBilateralAgreements, {
          fromOrganizationId: action.payload,
          status: ["INITIAL", "AGREEMENT"],
        }),
        call(apiGetBilateralAgreements, {
          toOrganizationId: action.payload,
          status: ["INITIAL", "AGREEMENT"],
        }),
      ]);
      return yield put(
        actions.getBilateralAgreementsSucceeded([
          ...sellerInfoRes.data.items,
          ...buyerInfoRes.data.items,
        ])
      );
    }
    const res = yield call(apiGetBilateralAgreements, {
      status: ["INITIAL", "AGREEMENT"],
    });
    yield put(actions.getBilateralAgreementsSucceeded([...res.data.items]));
  } catch (err) {
    yield put(actions.getBilateralAgreementsFailed());
  }
}

function* watchGetBilateralAgreementsHistory() {
  yield takeEvery(
    GET_BILATERAL_AGREEMENTS_HISTORY_REQUEST,
    getBilateralAgreementsHistory
  );
}

function* getBilateralAgreementsHistory(action) {
  try {
    if (Object.keys(action.payload).length === 1) {
      const res = yield call(
        apiGetBilateralAgreements,
        action.payload[Object.keys(action.payload)[0]]
      );

      const dataList = [...res.data.items];

      yield put(
        actions.getBilateralAgreementsHistorySucceeded({
          dataList,
          total: {
            totalItemCount: res.data.totalItemCount,
            totalPageCount: res.data.totalPageCount,
          },
        })
      );
    } else {
      const [sellerInfoRes, buyerInfoRes] = yield all([
        call(apiGetBilateralAgreements, {
          ...action.payload.sellerApiFilters,
        }),
        call(apiGetBilateralAgreements, {
          ...action.payload.buyerApiFilters,
        }),
      ]);

      const data = [...sellerInfoRes.data.items, ...buyerInfoRes.data.items];
      const dataList = data.filter(
        (d, index, arr) => index === arr.findIndex((item) => item.id === d.id)
      );
      yield put(
        actions.getBilateralAgreementsHistorySucceeded({
          dataList,
          sellerTotal: {
            totalItemCount: sellerInfoRes.data.totalItemCount,
            totalPageCount: sellerInfoRes.data.totalPageCount,
          },
          buyerTotal: {
            totalItemCount: buyerInfoRes.data.totalItemCount,
            totalPageCount: buyerInfoRes.data.totalPageCount,
          },
        })
      );
    }
  } catch (err) {
    yield put(actions.getBilateralAgreementsHistoryFailed());
  }
}
const apiGetCertificates = (reqParams) => {
  return API_GET("certificate", {
    ...reqParams,
    page: reqParams?.page || 0,
    size: 10,
  });
};

const apiGetBilateralAgreements = (reqParams) => {
  return API_GET("bilateralAgreement", {
    ...reqParams,
    page: reqParams?.page || 0,
    size: 10,
  });
};

export default function* bilateralAgreementsSaga() {
  yield all([
    fork(watchGetCertificates),
    fork(watchGetBilateralAgreements),
    fork(watchGetBilateralAgreementsHistory),
  ]);
}
